import { render, staticRenderFns } from "./group.vue?vue&type=template&id=524ea1f0&scoped=true&"
import script from "./group.js?vue&type=script&lang=js&"
export * from "./group.js?vue&type=script&lang=js&"
import style0 from "./group.css?vue&type=style&index=0&id=524ea1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ea1f0",
  null
  
)

export default component.exports